import React from 'react';
import { Button, MenuItem } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useRootStore } from '../../../../stores/BridgeProvider';
import VoucherTransactionForm from '../../../vouchers/VoucherTransactionForm';

const NewVoucherTransactionModal = ({ voucher, handleClose }) => {
  const { dealMapperStore } = useRootStore();

  return (
    <VoucherTransactionForm
      submitLabel="Submit"
      voucherId={voucher.VoucherId}
      passedVoucher={voucher}
      onSubmit={async values => {
        dealMapperStore.addVoucherTransaction({
          VoucherId: values.VoucherId,
          Category: values.CategoryId,
          Price: values.Price,
          Quantity: values.Quantity,
          Description: values.Description,
          Account: values.AccountId,
        });
        handleClose();
      }}
      menuItems={[
        <MenuItem key={1} component={Link} to="/accounts/new">
          New Account
        </MenuItem>,
        <MenuItem key={2} component={Link} to="/transaction-categories/new">
          New Transaction Category
        </MenuItem>,
      ]}
      buttons={[
        <Button
          key={1}
          variant="outlined"
          color="secondary"
          size="large"
          style={{
            margin: '5px',
          }}
          onClick={handleClose}
        >
          Cancel
        </Button>,
      ]}
    />
  );
};

export default NewVoucherTransactionModal;
